export default __webpack_public_path__ + "static/media/logo.04c7c230.png";